export const TELEHEALTH_MEETING_LINK = `/api/teleui/join-session`